import {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";

import {
  useNavigate,
} from "react-router-dom";

import {
  db,
} from "../firebase";

import "./WithdrawByUsdt.css";


/* =========================================================
   CONFIG
========================================================= */

const MINIMUM_WITHDRAW = 5;

const MAXIMUM_WITHDRAW = 100000;


/* =========================================================
   REQUIRED BETS
========================================================= */

const REQUIRED_BETS = 6;


/* =========================================================
   WITHDRAWAL SPEED OPTIONS
========================================================= */

const withdrawalOptions = [
  {
    id: "standard",
    label: "Standard",
    time: "24 Hours",
    fee: 5,
  },

  {
    id: "express",
    label: "Express",
    time: "30 Minutes",
    fee: 10,
  },
];


/* =========================================================
   COMPONENT
========================================================= */

export default function WithdrawByUsdt() {

  const navigate = useNavigate();

  // Keep this screen synchronized with the app-wide language selector.
  const [language, setLanguage] = useState(
    () => (localStorage.getItem("language") || "en").toLowerCase()
  );

  useEffect(() => {
    const syncLanguage = () =>
      setLanguage((localStorage.getItem("language") || "en").toLowerCase());
    window.addEventListener("languageChanged", syncLanguage);
    window.addEventListener("storage", syncLanguage);
    return () => {
      window.removeEventListener("languageChanged", syncLanguage);
      window.removeEventListener("storage", syncLanguage);
    };
  }, []);

  const translations = {
    sw: {
      "Standard":"Kawaida", "Express":"Haraka", "LIVE":"MOJA KWA MOJA", "BETS":"BETI", "Withdrawal Notice":"Taarifa ya Kutoa Fedha", "Go back":"Rudi nyuma",
      "DIGITAL ASSET":"MALI YA KIDIJITALI", "Crypto Withdraw":"Kutoa Crypto",
      "FREE USDT BALANCE":"SALIO HURU LA USDT", "Loading...":"Inapakia...",
      "Total USDT Balance":"Jumla ya Salio la USDT", "Used Forex Margin":"Margin ya Forex Iliyotumika",
      "SELECT BALANCE":"CHAGUA SALIO", "WITHDRAWAL ELIGIBILITY":"USTAHIKI WA KUTOA FEDHA",
      "BETS":"BETI", "Checking betting activity...":"Inakagua shughuli za kubeti...",
      "✓ Withdrawal requirement completed":"✓ Masharti ya kutoa fedha yametimizwa",
      "Destination":"Mahali pa Kupokea", "Select receiving wallet":"Chagua pochi ya kupokea",
      "Loading wallets...":"Inapakia pochi...", "Select crypto wallet":"Chagua pochi ya crypto",
      "Network":"Mtandao", "✓ VERIFIED":"✓ IMETHIBITISHWA",
      "RECEIVING ADDRESS":"ANWANI YA KUPOKEA", "Withdrawal Speed":"Kasi ya Kutoa Fedha",
      "Select processing priority":"Chagua kipaumbele cha uchakataji",
      "Select withdrawal speed":"Chagua kasi ya kutoa fedha", "Fee":"Ada",
      "Processing time:":"Muda wa uchakataji:", "FEE":"ADA",
      "Withdrawal Amount":"Kiasi cha Kutoa", "Enter amount in USDT":"Weka kiasi kwa USDT",
      "MAX":"KIKOMO", "MIN":"KIMA CHA CHINI", "LIVE BTC RATE":"KIWANGO CHA BTC KWA SASA",
      "Updating...":"Inasasisha...", "CONFIRM WITHDRAWAL":"THIBITISHA KUTOA FEDHA",
      "CHECKING ELIGIBILITY...":"INAKAGUA USTAHIKI...",
      "TRANSACTION PREVIEW":"MUHTASARI WA MUAMALA", "SECURE":"SALAMA",
      "Amount":"Kiasi", "Withdrawal speed":"Kasi ya kutoa fedha",
      "Processing time":"Muda wa uchakataji", "Processing fee":"Ada ya uchakataji",
      "YOU RECEIVE":"UNAPOKEA", "After processing fee":"Baada ya ada ya uchakataji",
      "Funds will be sent to the wallet selected above. Always verify the receiving address and network before continuing.":"Fedha zitatumwa kwenye pochi uliyochagua hapo juu. Hakikisha anwani ya kupokea na mtandao ni sahihi kabla ya kuendelea.",
      "BACK":"RUDI", "No wallets":"Hakuna pochi", "1 wallet":"Pochi 1", "wallets":"pochi",
    },
    fr: {"Standard":"Standard","Express":"Express","LIVE":"EN DIRECT","Withdrawal Notice":"Avis de retrait","Go back":"Retour","DIGITAL ASSET":"ACTIF NUMÉRIQUE","Crypto Withdraw":"Retrait crypto","FREE USDT BALANCE":"SOLDE USDT DISPONIBLE","Loading...":"Chargement...","Total USDT Balance":"Solde USDT total","Used Forex Margin":"Marge Forex utilisée","SELECT BALANCE":"CHOISIR LE SOLDE","WITHDRAWAL ELIGIBILITY":"ÉLIGIBILITÉ AU RETRAIT","Destination":"Destination","Select receiving wallet":"Choisir le portefeuille de réception","Loading wallets...":"Chargement des portefeuilles...","Select crypto wallet":"Choisir un portefeuille crypto","Network":"Réseau","RECEIVING ADDRESS":"ADRESSE DE RÉCEPTION","Withdrawal Speed":"Vitesse de retrait","Select processing priority":"Choisir la priorité de traitement","Select withdrawal speed":"Choisir la vitesse de retrait","Withdrawal Amount":"Montant du retrait","Enter amount in USDT":"Saisir le montant en USDT","LIVE BTC RATE":"TAUX BTC EN DIRECT","Updating...":"Mise à jour...","CONFIRM WITHDRAWAL":"CONFIRMER LE RETRAIT","TRANSACTION PREVIEW":"APERÇU DE LA TRANSACTION","SECURE":"SÉCURISÉ","Amount":"Montant","Withdrawal speed":"Vitesse de retrait","Processing time":"Délai de traitement","Processing fee":"Frais de traitement","YOU RECEIVE":"VOUS RECEVEZ","After processing fee":"Après les frais de traitement","BACK":"RETOUR","No wallets":"Aucun portefeuille"},
    es: {"Standard":"Estándar","Express":"Exprés","LIVE":"EN VIVO","Withdrawal Notice":"Aviso de retiro","Go back":"Volver","DIGITAL ASSET":"ACTIVO DIGITAL","Crypto Withdraw":"Retiro de cripto","FREE USDT BALANCE":"SALDO DISPONIBLE USDT","Loading...":"Cargando...","Total USDT Balance":"Saldo total USDT","Used Forex Margin":"Margen Forex usado","SELECT BALANCE":"SELECCIONAR SALDO","WITHDRAWAL ELIGIBILITY":"ELEGIBILIDAD DE RETIRO","Destination":"Destino","Select receiving wallet":"Selecciona la billetera receptora","Loading wallets...":"Cargando billeteras...","Select crypto wallet":"Seleccionar billetera cripto","Network":"Red","RECEIVING ADDRESS":"DIRECCIÓN DE RECEPCIÓN","Withdrawal Speed":"Velocidad de retiro","Select processing priority":"Selecciona prioridad de procesamiento","Select withdrawal speed":"Seleccionar velocidad de retiro","Withdrawal Amount":"Importe del retiro","Enter amount in USDT":"Introduce el importe en USDT","LIVE BTC RATE":"TASA BTC EN VIVO","Updating...":"Actualizando...","CONFIRM WITHDRAWAL":"CONFIRMAR RETIRO","TRANSACTION PREVIEW":"RESUMEN DE TRANSACCIÓN","SECURE":"SEGURO","Amount":"Importe","Withdrawal speed":"Velocidad de retiro","Processing time":"Tiempo de procesamiento","Processing fee":"Tarifa de procesamiento","YOU RECEIVE":"RECIBES","After processing fee":"Después de la tarifa","BACK":"VOLVER","No wallets":"No hay billeteras"},
    pt: {"Standard":"Padrão","Express":"Expresso","LIVE":"AO VIVO","Withdrawal Notice":"Aviso de saque","Go back":"Voltar","DIGITAL ASSET":"ATIVO DIGITAL","Crypto Withdraw":"Saque de cripto","FREE USDT BALANCE":"SALDO USDT DISPONÍVEL","Loading...":"Carregando...","Total USDT Balance":"Saldo total USDT","Used Forex Margin":"Margem Forex utilizada","SELECT BALANCE":"SELECIONAR SALDO","WITHDRAWAL ELIGIBILITY":"ELEGIBILIDADE PARA SAQUE","Destination":"Destino","Select receiving wallet":"Selecione a carteira de recebimento","Loading wallets...":"Carregando carteiras...","Select crypto wallet":"Selecionar carteira cripto","Network":"Rede","RECEIVING ADDRESS":"ENDEREÇO DE RECEBIMENTO","Withdrawal Speed":"Velocidade do saque","Select processing priority":"Selecione a prioridade de processamento","Select withdrawal speed":"Selecione a velocidade do saque","Withdrawal Amount":"Valor do saque","Enter amount in USDT":"Insira o valor em USDT","LIVE BTC RATE":"COTAÇÃO BTC AO VIVO","Updating...":"Atualizando...","CONFIRM WITHDRAWAL":"CONFIRMAR SAQUE","TRANSACTION PREVIEW":"RESUMO DA TRANSAÇÃO","SECURE":"SEGURO","Amount":"Valor","Withdrawal speed":"Velocidade do saque","Processing time":"Tempo de processamento","Processing fee":"Taxa de processamento","YOU RECEIVE":"VOCÊ RECEBE","After processing fee":"Após a taxa de processamento","BACK":"VOLTAR","No wallets":"Nenhuma carteira"},
    de: {"Standard":"Standard","Express":"Express","LIVE":"LIVE","Withdrawal Notice":"Auszahlungshinweis","Go back":"Zurück","DIGITAL ASSET":"DIGITALES ASSET","Crypto Withdraw":"Krypto-Auszahlung","FREE USDT BALANCE":"VERFÜGBARES USDT-GUTHABEN","Loading...":"Wird geladen...","Total USDT Balance":"USDT-Gesamtguthaben","Used Forex Margin":"Verwendete Forex-Margin","SELECT BALANCE":"GUTHABEN AUSWÄHLEN","WITHDRAWAL ELIGIBILITY":"AUSZAHLUNGSBERECHTIGUNG","Destination":"Ziel","Select receiving wallet":"Empfänger-Wallet auswählen","Loading wallets...":"Wallets werden geladen...","Select crypto wallet":"Krypto-Wallet auswählen","Network":"Netzwerk","RECEIVING ADDRESS":"EMPFANGSADRESSE","Withdrawal Speed":"Auszahlungsgeschwindigkeit","Select processing priority":"Verarbeitungspriorität auswählen","Select withdrawal speed":"Auszahlungsgeschwindigkeit auswählen","Withdrawal Amount":"Auszahlungsbetrag","Enter amount in USDT":"Betrag in USDT eingeben","LIVE BTC RATE":"BTC-LIVEKURS","Updating...":"Wird aktualisiert...","CONFIRM WITHDRAWAL":"AUSZAHLUNG BESTÄTIGEN","TRANSACTION PREVIEW":"TRANSAKTIONSÜBERSICHT","SECURE":"SICHER","Amount":"Betrag","Withdrawal speed":"Auszahlungsgeschwindigkeit","Processing time":"Bearbeitungszeit","Processing fee":"Bearbeitungsgebühr","YOU RECEIVE":"SIE ERHALTEN","After processing fee":"Nach Bearbeitungsgebühr","BACK":"ZURÜCK","No wallets":"Keine Wallets"},
    it: {"Standard":"Standard","Express":"Rapido","LIVE":"IN DIRETTA","Withdrawal Notice":"Avviso di prelievo","Go back":"Indietro","DIGITAL ASSET":"ASSET DIGITALE","Crypto Withdraw":"Prelievo crypto","FREE USDT BALANCE":"SALDO USDT DISPONIBILE","Loading...":"Caricamento...","Total USDT Balance":"Saldo USDT totale","Used Forex Margin":"Margine Forex utilizzato","SELECT BALANCE":"SELEZIONA SALDO","WITHDRAWAL ELIGIBILITY":"IDONEITÀ AL PRELIEVO","Destination":"Destinazione","Select receiving wallet":"Seleziona il portafoglio ricevente","Loading wallets...":"Caricamento portafogli...","Select crypto wallet":"Seleziona portafoglio crypto","Network":"Rete","RECEIVING ADDRESS":"INDIRIZZO DI RICEZIONE","Withdrawal Speed":"Velocità di prelievo","Select processing priority":"Seleziona priorità di elaborazione","Select withdrawal speed":"Seleziona velocità di prelievo","Withdrawal Amount":"Importo del prelievo","Enter amount in USDT":"Inserisci importo in USDT","LIVE BTC RATE":"TASSO BTC LIVE","Updating...":"Aggiornamento...","CONFIRM WITHDRAWAL":"CONFERMA PRELIEVO","TRANSACTION PREVIEW":"RIEPILOGO TRANSAZIONE","SECURE":"SICURO","Amount":"Importo","Withdrawal speed":"Velocità di prelievo","Processing time":"Tempo di elaborazione","Processing fee":"Commissione di elaborazione","YOU RECEIVE":"RICEVI","After processing fee":"Dopo la commissione","BACK":"INDIETRO"},
    ar: {"Standard":"عادي","Express":"سريع","LIVE":"مباشر","Withdrawal Notice":"إشعار السحب","Go back":"رجوع","DIGITAL ASSET":"أصل رقمي","Crypto Withdraw":"سحب العملات الرقمية","FREE USDT BALANCE":"رصيد USDT المتاح","Loading...":"جارٍ التحميل...","Total USDT Balance":"إجمالي رصيد USDT","Used Forex Margin":"هامش الفوركس المستخدم","SELECT BALANCE":"اختر الرصيد","WITHDRAWAL ELIGIBILITY":"أهلية السحب","Destination":"الوجهة","Select receiving wallet":"اختر محفظة الاستلام","Loading wallets...":"جارٍ تحميل المحافظ...","Select crypto wallet":"اختر محفظة العملات الرقمية","Network":"الشبكة","RECEIVING ADDRESS":"عنوان الاستلام","Withdrawal Speed":"سرعة السحب","Select processing priority":"اختر أولوية المعالجة","Select withdrawal speed":"اختر سرعة السحب","Withdrawal Amount":"مبلغ السحب","Enter amount in USDT":"أدخل المبلغ بعملة USDT","LIVE BTC RATE":"سعر BTC المباشر","Updating...":"جارٍ التحديث...","CONFIRM WITHDRAWAL":"تأكيد السحب","TRANSACTION PREVIEW":"معاينة المعاملة","SECURE":"آمن","Amount":"المبلغ","Withdrawal speed":"سرعة السحب","Processing time":"وقت المعالجة","Processing fee":"رسوم المعالجة","YOU RECEIVE":"ستستلم","After processing fee":"بعد رسوم المعالجة","BACK":"رجوع"}
  };

  const t = (key) => translations[language]?.[key] || key;


  /* =======================================================
     USERNAME
  ======================================================= */

  const username =
    localStorage.getItem("username") || "";


  /* =======================================================
     BALANCE STATE
  ======================================================= */

  const [
    balance,
    setBalance,
  ] = useState(0);


  /*
   * Balances zinazopatikana kwenye users document:
   *
   * usdtBalanceOther
   * usdtBalance
   */
  const [
    balanceSources,
    setBalanceSources,
  ] = useState({
    usdtBalanceOther: 0,
    usdtBalance: 0,
  });


  /*
   * Balance inayotumika kwa withdrawal.
   *
   * Kama zote mbili zina balance:
   * default = usdtBalanceOther
   *
   * Kama moja tu ina balance:
   * hiyo ndiyo inachaguliwa automatically.
   */
  const [
    balanceType,
    setBalanceType,
  ] = useState("usdtBalanceOther");


  const [
    amount,
    setAmount,
  ] = useState("");

  const [usedForexMargin, setUsedForexMargin] = useState(0);
  const [freeBalance, setFreeBalance] = useState(0);
  const [marginLoading, setMarginLoading] = useState(true);
  const [hasOpenForexOrders, setHasOpenForexOrders] = useState(false);
  const [
    wallets,
    setWallets,
  ] = useState([]);


  const [
    selectedWallet,
    setSelectedWallet,
  ] = useState(-1);


  const [
    loading,
    setLoading,
  ] = useState(true);


  const [
    balanceLoading,
    setBalanceLoading,
  ] = useState(true);


  /* =======================================================
     BET STATE
  ======================================================= */

  const [
    totalBets,
    setTotalBets,
  ] = useState(0);


  const [
    betsLoading,
    setBetsLoading,
  ] = useState(true);


  /* =======================================================
     BTC RATE
  ======================================================= */

  const [
    btcRate,
    setBtcRate,
  ] = useState(0);


  const [
    rateLoading,
    setRateLoading,
  ] = useState(false);


  /* =======================================================
     AMOUNT ERROR
  ======================================================= */

  const [
    amountError,
    setAmountError,
  ] = useState("");


  /* =======================================================
     WITHDRAWAL SPEED
  ======================================================= */

  const [
    withdrawalType,
    setWithdrawalType,
  ] = useState("");


  const [
    withdrawalSpeedError,
    setWithdrawalSpeedError,
  ] = useState("");


  /* =======================================================
     NOTICE
  ======================================================= */

  const [
    notice,
    setNotice,
  ] = useState({
    visible: false,
    message: "",
    type: "warning",
  });


  /* =======================================================
     SHOW NOTICE
  ======================================================= */

  const showNotice = (
    message,
    type = "warning"
  ) => {

    setNotice({
      visible: true,
      message,
      type,
    });

  };


  /* =======================================================
     HIDE NOTICE
  ======================================================= */

  const hideNotice = () => {

    setNotice({
      visible: false,
      message: "",
      type: "warning",
    });

  };


  /* =======================================================
     BACK
  ======================================================= */

  const handleBack = () => {

    if (
      window.history.length > 1
    ) {

      navigate(-1);

      return;

    }


    navigate(
      "/withdraw",
      {
        replace: true,
      }
    );

  };


  /* =======================================================
     SELECTED WITHDRAWAL OPTION
  ======================================================= */

  const selectedWithdrawalOption =
    useMemo(() => {

      return (
        withdrawalOptions.find(
          (option) =>
            option.id === withdrawalType
        ) || null
      );

    }, [
      withdrawalType,
    ]);


  /* =======================================================
     CURRENT WITHDRAWAL FEE
  ======================================================= */

  const withdrawalFee =
    selectedWithdrawalOption
      ? Number(
          selectedWithdrawalOption.fee
        )
      : 0;


  /* =======================================================
     MASK ADDRESS
  ======================================================= */

  const maskAddress = (
    address = ""
  ) => {

    const value =
      String(
        address || ""
      ).trim();


    if (!value) {

      return "";

    }


    if (
      value.length <= 14
    ) {

      return value;

    }


    return (
      value.slice(0, 7) +
      "••••••" +
      value.slice(-7)
    );

  };


  /* =======================================================
     SELECTED WALLET
  ======================================================= */

  const selectedWalletData =
    selectedWallet >= 0 &&
    wallets[selectedWallet]
      ? wallets[selectedWallet]
      : null;


  /* =======================================================
     BTC WALLET
  ======================================================= */

  const isBTCWallet =
    String(
      selectedWalletData?.coin || ""
    )
      .toUpperCase()
      .includes("BTC");


  /* =======================================================
     RECEIVE CURRENCY
  ======================================================= */

  const receiveCurrency =
    isBTCWallet
      ? "BTC"
      : "USDT";


  /* =======================================================
     AMOUNT NUMBER
  ======================================================= */

  const amountNumber =
    Number(
      amount || 0
    );


  /* =======================================================
     FEE AMOUNT
  ======================================================= */

  const feeAmount =
    amountNumber > 0 &&
    selectedWithdrawalOption
      ? (
          amountNumber *
          withdrawalFee
        ) / 100
      : 0;


  /* =======================================================
     ACTUAL USDT
  ======================================================= */

  const actualAmountUsdt =
    amountNumber > 0
      ? Math.max(
          amountNumber - feeAmount,
          0
        )
      : 0;


  /* =======================================================
     ACTUAL BTC
  ======================================================= */

  const actualAmountBtc =
    actualAmountUsdt > 0 &&
    btcRate > 0
      ? actualAmountUsdt * btcRate
      : 0;


  /* =======================================================
     DISPLAY RECEIVE
  ======================================================= */

  const displayReceiveAmount =
    isBTCWallet
      ? actualAmountBtc.toFixed(8)
      : actualAmountUsdt.toFixed(2);


  /* =======================================================
     BTC CONVERSION
  ======================================================= */

  const conversionText =
    isBTCWallet && btcRate > 0
      ? `1 USDT = ${btcRate.toFixed(8)} BTC`
      : "-";


  /* =======================================================
     WALLET COUNT
  ======================================================= */

  const walletCountText =
    useMemo(() => {

      if (wallets.length === 0) {
        return "No wallets";
      }

      if (wallets.length === 1) {
        return "1 wallet";
      }

      return `${wallets.length} wallets`;

    }, [
      wallets.length,
    ]);


  /* =======================================================
     BALANCE AVAILABILITY
  ======================================================= */

  const hasOtherBalance =
    Number(
      balanceSources.usdtBalanceOther || 0
    ) > 0;


  const hasNormalBalance =
    Number(
      balanceSources.usdtBalance || 0
    ) > 0;


  /*
   * Selector itaonekana ONLY kama
   * balances zote mbili zina fedha.
   */
  const showBalanceSelector =
    hasOtherBalance &&
    hasNormalBalance;


  /* =======================================================
     BET PROGRESS
  ======================================================= */

  const betProgress =
    Math.min(
      totalBets,
      REQUIRED_BETS
    );


  const betProgressPercent =
    Math.min(
      (
        totalBets /
        REQUIRED_BETS
      ) * 100,
      100
    );


  /* =======================================================
     HANDLE BALANCE TYPE CHANGE
  ======================================================= */

  const handleBalanceTypeChange =
    (event) => {

      const type =
        event.target.value;


      setBalanceType(
        type
      );


      const selectedBalance =
        Number(
          balanceSources[type] || 0
        );


      setBalance(
        selectedBalance
      );


      /*
       * Amount ya zamani isionekane
       * wakati user amebadilisha balance.
       */
      setAmount("");

      setAmountError("");

    };


  /* =======================================================
     FETCH BOTH BALANCES
  ======================================================= */

  useEffect(() => {

    let mounted = true;


    const fetchBalance =
      async () => {

        if (!username) {

          setBalanceLoading(false);

          navigate(
            "/login",
            {
              replace: true,
            }
          );

          return;
        }


        try {

          setBalanceLoading(true);


          const userQuery =
            query(
              collection(
                db,
                "users"
              ),

              where(
                "username",
                "==",
                username
              )
            );


          const snapshot =
            await getDocs(
              userQuery
            );


          if (!mounted) {
            return;
          }


          if (snapshot.empty) {

            setBalanceSources({
              usdtBalanceOther: 0,
              usdtBalance: 0,
            });

            setBalanceType(
              "usdtBalanceOther"
            );

            setBalance(0);

            return;
          }


          const userData =
            snapshot.docs[0].data();


          const otherBalance =
            Number(
              userData.usdtBalanceOther ?? 0
            );


          const normalBalance =
            Number(
              userData.usdtBalance ?? 0
            );


          const sources = {

            usdtBalanceOther:
              Number.isFinite(
                otherBalance
              )
                ? otherBalance
                : 0,

            usdtBalance:
              Number.isFinite(
                normalBalance
              )
                ? normalBalance
                : 0,

          };


          setBalanceSources(
            sources
          );


          /*
           * DEFAULT BALANCE LOGIC
           *
           * 1. Both have balance
           *    -> usdtBalanceOther
           *
           * 2. Only other has balance
           *    -> usdtBalanceOther
           *
           * 3. Only normal has balance
           *    -> usdtBalance
           *
           * 4. Both are empty
           *    -> usdtBalanceOther
           */

          let defaultType =
            "usdtBalanceOther";


          if (
            sources.usdtBalanceOther <= 0 &&
            sources.usdtBalance > 0
          ) {

            defaultType =
              "usdtBalance";

          }


          setBalanceType(
            defaultType
          );


          setBalance(
            Number(
              sources[defaultType] || 0
            )
          );


        } catch (error) {

          console.error(
            "USDT balance error:",
            error
          );


          if (mounted) {

            setBalanceSources({
              usdtBalanceOther: 0,
              usdtBalance: 0,
            });

            setBalanceType(
              "usdtBalanceOther"
            );

            setBalance(0);


            showNotice(
              "Unable to load USDT balances.",
              "error"
            );

          }

        } finally {

          if (mounted) {

            setBalanceLoading(
              false
            );

          }

        }

      };


    fetchBalance();


    return () => {

      mounted = false;

    };

  }, [
    username,
    navigate,
  ]);






  // =======================================================
  // FETCH FOREX MARGIN AND FREE BALANCE
  // =======================================================
  useEffect(() => {
    let mounted = true;

    const fetchForexMargin = async () => {
      if (!username) {
        setUsedForexMargin(0);
        setFreeBalance(0);
        setMarginLoading(false);
        return;
      }

      try {
        setMarginLoading(true);

        const forexQuery = query(
          collection(db, "Forex"),
          where("username", "==", username)
        );

        const forexSnapshot = await getDocs(forexQuery);

        if (!mounted) return;

     
const activeOrders = forexSnapshot.docs.filter((item) => {
  const order = item.data();
  const status = String(order.status || "").toLowerCase();

  const closed =
    order.closed === true ||
    [
      "closed",
      "cancelled",
      "canceled",
      "rejected",
      "expired",
    ].includes(status);

  return (
    !closed &&
    (
      status === "open" ||
      status === "pending" ||
      order.isPending === true
    )
  );
});

const usedMargin = activeOrders.reduce((total, item) => {
  const order = item.data();
  const margin = Number(
    order.marginRequired ?? order.margin ?? 0
  );

  if (!Number.isFinite(margin) || margin < 0) {
    throw new Error("Invalid margin on a Forex order.");
  }

  return total + margin;
}, 0);

setHasOpenForexOrders(activeOrders.length > 0);
setUsedForexMargin(usedMargin);




      } catch (error) {
        console.error("Forex margin loading error:", error);

        if (mounted) {
          setUsedForexMargin(0);
          setHasOpenForexOrders(false);
          showNotice(
            "Unable to verify Forex margin. Withdrawal is temporarily unavailable.",
            "error"
          );
        }
      } finally {
        if (mounted) {
          setMarginLoading(false);
        }
      }
    };

    fetchForexMargin();

    return () => {
      mounted = false;
    };
  }, [username]);

  // Free balance hutumia balance source iliyochaguliwa.
  useEffect(() => {
    setFreeBalance(
      Math.max(
        0,
        Number(balance || 0) -
          Number(usedForexMargin || 0)
      )
    );
  }, [balance, usedForexMargin]);






  /* =======================================================
     FETCH BETS
  ======================================================= */

  useEffect(() => {

    let mounted = true;


    const fetchBets =
      async () => {

        if (!username) {

          if (mounted) {

            setTotalBets(0);

            setBetsLoading(false);

          }

          return;
        }


        try {

          setBetsLoading(true);


          const antQuery =
            query(
              collection(
                db,
                "antscore"
              ),

              where(
                "username",
                "==",
                username
              )
            );


          const correctQuery =
            query(
              collection(
                db,
                "correctscore"
              ),

              where(
                "username",
                "==",
                username
              )
            );


          const [
            antSnapshot,
            correctSnapshot,
          ] =
            await Promise.all([
              getDocs(
                antQuery
              ),

              getDocs(
                correctQuery
              ),
            ]);


          if (!mounted) {
            return;
          }


          const total =
            antSnapshot.size +
            correctSnapshot.size;


          setTotalBets(
            total
          );


        } catch (error) {

          console.error(
            "USDT bet loading error:",
            error
          );


          if (mounted) {

            setTotalBets(0);

          }


        } finally {

          if (mounted) {

            setBetsLoading(false);

          }

        }

      };


    fetchBets();


    return () => {

      mounted = false;

    };

  }, [
    username,
  ]);


  /* =======================================================
     FETCH CRYPTO WALLETS
  ======================================================= */

  useEffect(() => {

    let mounted = true;


    const fetchWallets =
      async () => {

        if (!username) {

          navigate(
            "/login",
            {
              replace: true,
            }
          );

          return;
        }


        try {

          setLoading(true);


          const securityRef =
            doc(
              db,
              "security",
              username
            );


          const snapshot =
            await getDoc(
              securityRef
            );


          if (!mounted) {
            return;
          }


          if (!snapshot.exists()) {

            setWallets([]);

            showNotice(
              "Please add a crypto wallet first.",
              "warning"
            );


            setTimeout(() => {

              navigate(
                "/Crypto-Wallets"
              );

            }, 900);


            return;
          }


          const data =
            snapshot.data();


          const savedWallets =
            Array.isArray(
              data.cryptoWallets
            )
              ? data.cryptoWallets
              : [];


          if (
            savedWallets.length === 0
          ) {

            setWallets([]);

            showNotice(
              "Please add a crypto wallet first.",
              "warning"
            );


            setTimeout(() => {

              navigate(
                "/Crypto-Wallets"
              );

            }, 900);


            return;
          }


          const validWallets =
            savedWallets.filter(
              (wallet) => {

                return (
                  wallet &&
                  String(
                    wallet.coin || ""
                  ).trim() &&
                  String(
                    wallet.address || ""
                  ).trim()
                );

              }
            );


          if (
            validWallets.length === 0
          ) {

            setWallets([]);

            showNotice(
              "No valid crypto wallet found.",
              "warning"
            );

            return;
          }


          setWallets(
            validWallets
          );


        } catch (error) {

          console.error(
            "Crypto wallet loading error:",
            error
          );


          if (mounted) {

            setWallets([]);

            showNotice(
              "Failed to load crypto wallets.",
              "error"
            );

          }

        } finally {

          if (mounted) {

            setLoading(false);

          }

        }

      };


    fetchWallets();


    return () => {

      mounted = false;

    };

  }, [
    username,
    navigate,
  ]);


  /* =======================================================
     FETCH BTC PRICE
  ======================================================= */

  useEffect(() => {

    let mounted = true;


    const fetchBtcRate =
      async () => {

        try {

          setRateLoading(true);


          const response =
            await fetch(
              "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd"
            );


          if (!response.ok) {

            throw new Error(
              "BTC rate request failed"
            );

          }


          const data =
            await response.json();


          const btcUsd =
            Number(
              data?.bitcoin?.usd || 0
            );


          if (
            btcUsd > 0 &&
            mounted
          ) {

            setBtcRate(
              1 / btcUsd
            );

          }


        } catch (error) {

          console.error(
            "BTC rate error:",
            error
          );


          if (mounted) {

            setBtcRate(0);

          }

        } finally {

          if (mounted) {

            setRateLoading(false);

          }

        }

      };


    fetchBtcRate();


    return () => {

      mounted = false;

    };

  }, []);


  /* =======================================================
     WALLET CHANGE
  ======================================================= */

  const handleWalletChange =
    (event) => {

      const index =
        Number(
          event.target.value
        );


      setSelectedWallet(
        index
      );


      setAmountError("");

    };


  /* =======================================================
     WITHDRAWAL SPEED CHANGE
  ======================================================= */

  const handleWithdrawalSpeedChange =
    (event) => {

      const value =
        event.target.value;


      setWithdrawalType(
        value
      );


      setWithdrawalSpeedError(
        ""
      );

    };


  /* =======================================================
     AMOUNT CHANGE
  ======================================================= */

  const handleAmountChange =
    (event) => {

      const raw =
        event.target.value;


      if (raw === "") {

        setAmount("");

        setAmountError("");

        return;
      }


      const numeric =
        Number(raw);


      if (
        Number.isNaN(numeric)
      ) {

        return;
      }


      let nextValue =
        numeric;


        if (numeric > freeBalance) {
          nextValue = freeBalance;
        }


      if (
        numeric >
        MAXIMUM_WITHDRAW
      ) {

        nextValue =
          MAXIMUM_WITHDRAW;
      }


      setAmount(
        String(
          nextValue
        )
      );


      if (
        nextValue <
        MINIMUM_WITHDRAW
      ) {

        setAmountError(
          `Minimum is ${MINIMUM_WITHDRAW} USDT`
        );

      } else {

        setAmountError("");

      }

    };


  /* =======================================================
     USE MAX
  ======================================================= */

  const handleMax =
    () => {

      const max = Math.min(
        Number(freeBalance || 0),
        MAXIMUM_WITHDRAW
      );

      if (max <= 0) {

        showNotice(
          "You do not have available USDT balance.",
          "warning"
        );

        return;
      }


      setAmount(
        String(max)
      );


      if (
        max < MINIMUM_WITHDRAW
      ) {

        setAmountError(
          `Minimum is ${MINIMUM_WITHDRAW} USDT`
        );

      } else {

        setAmountError("");

      }

    };


  /* =======================================================
     SUBMIT
  ======================================================= */

  const handleSubmit =
    () => {

      if (
        loading ||
        balanceLoading ||
        betsLoading ||
        marginLoading
      ) {
        showNotice(
          "Please wait while account balances are loading.",
          "warning"
        );
        return;
      }


      /* -----------------------------------------------
         REQUIRED BETS
      ----------------------------------------------- */

      if (
        totalBets < REQUIRED_BETS
      ) {

        const remaining =
          REQUIRED_BETS -
          totalBets;


        showNotice(
          `You must complete ${REQUIRED_BETS} valid bets first. Remaining: ${remaining} bet${
            remaining === 1
              ? ""
              : "s"
          }.`,
          "warning"
        );

        return;
      }


      /* -----------------------------------------------
         WITHDRAWAL SPEED
      ----------------------------------------------- */

      if (
        !withdrawalType ||
        !selectedWithdrawalOption
      ) {

        setWithdrawalSpeedError(
          "Please select withdrawal speed."
        );


        showNotice(
          "Please select withdrawal speed.",
          "warning"
        );

        return;
      }


      /* -----------------------------------------------
         BALANCE
      ----------------------------------------------- */

      if (balance <= 0) {

        showNotice(
          "No USDT balance available in the selected balance.",
          "warning"
        );

        return;
      }


      /* -----------------------------------------------
         AMOUNT
      ----------------------------------------------- */

      if (
        !amount ||
        amountNumber <= 0
      ) {

        setAmountError(
          "Enter withdrawal amount"
        );


        showNotice(
          "Enter the amount you want to withdraw.",
          "warning"
        );

        return;
      }


      /* -----------------------------------------------
         MINIMUM
      ----------------------------------------------- */

      if (
        amountNumber < MINIMUM_WITHDRAW
      ) {

        setAmountError(
          `Minimum is ${MINIMUM_WITHDRAW} USDT`
        );


        showNotice(
          `Minimum withdrawal is ${MINIMUM_WITHDRAW} USDT.`,
          "warning"
        );

        return;
      }


      /* -----------------------------------------------
         MAXIMUM
      ----------------------------------------------- */

      if (
        amountNumber > MAXIMUM_WITHDRAW
      ) {

        setAmountError(
          `Maximum is ${MAXIMUM_WITHDRAW} USDT`
        );


        showNotice(
          `Maximum withdrawal is ${MAXIMUM_WITHDRAW} USDT.`,
          "warning"
        );

        return;
      }


      /* -----------------------------------------------
         BALANCE CHECK
      ----------------------------------------------- */

      if (amountNumber > freeBalance) {
        setAmountError("Insufficient free USDT balance");
      
        showNotice(
          `Available after Forex margin: ${freeBalance.toFixed(2)} USDT.`,
          "error"
        );
      
        return;
      }

      /* -----------------------------------------------
         WALLET
      ----------------------------------------------- */

      if (!selectedWalletData) {

        showNotice(
          "Select a crypto wallet.",
          "warning"
        );

        return;
      }


      /* -----------------------------------------------
         WALLET ADDRESS
      ----------------------------------------------- */

      const walletAddress =
        String(
          selectedWalletData.address || ""
        ).trim();


      if (
        !walletAddress ||
        walletAddress.length < 10
      ) {

        showNotice(
          "Selected wallet address is invalid.",
          "error"
        );

        return;
      }


      /* -----------------------------------------------
         BTC RATE
      ----------------------------------------------- */

      if (
        isBTCWallet &&
        btcRate <= 0
      ) {

        showNotice(
          "BTC conversion rate is unavailable. Try again.",
          "error"
        );

        return;
      }


      /* -----------------------------------------------
         RECEIVE AMOUNT
      ----------------------------------------------- */

      if (
        actualAmountUsdt <= 0
      ) {

        showNotice(
          "Amount after fee is invalid.",
          "error"
        );

        return;
      }


      /* -----------------------------------------------
         FINAL FEE
      ----------------------------------------------- */

      const finalFee =
        Number(
          selectedWithdrawalOption.fee
        );


      const finalFeeAmount =
        (
          amountNumber *
          finalFee
        ) / 100;


      const finalReceiveUsdt =
        amountNumber -
        finalFeeAmount;


      if (
        finalReceiveUsdt <= 0
      ) {

        showNotice(
          "Withdrawal amount is too small after processing fee.",
          "error"
        );

        return;
      }


      /* -----------------------------------------------
         FINAL WALLET
      ----------------------------------------------- */

      const wallet = {

        ...selectedWalletData,

        selectedAddress:
          walletAddress,

        selectedNetwork:
          String(
            selectedWalletData.network || ""
          ).trim(),

        selectedCoin:
          String(
            selectedWalletData.coin || ""
          ).trim(),

      };


      /* -----------------------------------------------
         NAVIGATE
      ----------------------------------------------- */

      navigate(
        "/Confirmed-Withdraw",
        {
          state: {

            amount:
              amountNumber,


            wallet:
              wallet,


            fee:
              finalFee,


            feeAmount:
              Number(
                finalFeeAmount.toFixed(2)
              ),


            actualAmountUsdt:
              Number(
                finalReceiveUsdt.toFixed(2)
              ),


            actualAmountBtc:
              Number(
                actualAmountBtc.toFixed(8)
              ),


            actualAmount:
              isBTCWallet
                ? actualAmountBtc.toFixed(8)
                : finalReceiveUsdt.toFixed(2),


            receiveCurrency:
              receiveCurrency,


            sourceCurrency:
              "USDT",


            targetCurrency:
              receiveCurrency,


            conversionRate:
              isBTCWallet
                ? btcRate
                : null,


            withdrawalType:
              selectedWithdrawalOption.id,


            withdrawalSpeed:
              selectedWithdrawalOption.label,


            processingTime:
              selectedWithdrawalOption.time,


            totalBets:
              totalBets,


            requiredBets:
              REQUIRED_BETS,


            /*
             * BALANCE SOURCE
             *
             * Confirmed-Withdraw inaweza kujua
             * ni balance gani user alichagua.
             */

            balanceType:
              balanceType,


            balanceSource:
              balanceType,


            availableBalance:
              Number(
                balance
              ),

          },
        }
      );

    };


  /* =======================================================
     RENDER
  ======================================================= */

  return (

    <div
      className="digital-usdt-withdraw-page"
    >

      {/* =================================================
          NOTICE
      ================================================= */}

      {notice.visible && (

        <div
          className="digital-withdraw-notice-overlay"
          onClick={hideNotice}
        >

          <div
            className={
              `digital-withdraw-notice notice-${notice.type}`
            }

            onClick={(event) =>
              event.stopPropagation()
            }
          >

            <div
              className="notice-symbol"
            >

              {notice.type === "error"
                ? "!"
                : notice.type === "success"
                  ? "✓"
                  : "!"
              }

            </div>


            <div
              className="notice-text"
            >

              <strong>
                {t("Withdrawal Notice")}
              </strong>

              <span>
                {notice.message}
              </span>

            </div>


            <button
              type="button"
              onClick={hideNotice}
              className="notice-close"
            >
              ×
            </button>

          </div>

        </div>

      )}


      {/* =================================================
          HEADER
      ================================================= */}

      <header
        className="digital-withdraw-header"
      >

        <button
          type="button"
          className="digital-back-button"
          onClick={handleBack}
          aria-label={t("Go back")}
        >
          ‹
        </button>


        <div
          className="digital-header-center"
        >

          <span>
            {t("DIGITAL ASSET")}
          </span>

          <h1>
            {t("Crypto Withdraw")}
          </h1>

        </div>


        <div
          className="digital-header-status"
        >

          <i />

          {t("LIVE")}

        </div>

      </header>


      {/* =================================================
          MAIN
      ================================================= */}

      <main
        className="digital-withdraw-content"
      >

      

{/* =================================================
    BALANCE CARD
================================================= */}



<section className="digital-balance-card">
  <div className="digital-balance-top">
    <span>{t("FREE USDT BALANCE")}</span>
    <span className="balance-network">● USDT</span>
  </div>

  <div className="digital-balance-value">
    {balanceLoading || marginLoading
      ? t("Loading...")
      : `${Number(freeBalance || 0).toFixed(2)} USDT`}
  </div>

  {hasOpenForexOrders && (
    <div className="digital-balance-details">
      <div className="digital-balance-bottom">
        <span>{t("Total USDT Balance")}</span>
        <strong>
          {Number(balance || 0).toFixed(2)} USDT
        </strong>
      </div>

      <div className="digital-balance-bottom">
        <span>{t("Used Forex Margin")}</span>
        <strong>
          {Number(usedForexMargin || 0).toFixed(2)} USDT
        </strong>
      </div>
    </div>
  )}

  {showBalanceSelector && (
    <div className="digital-balance-selector">
      <label htmlFor="withdraw-balance-type">
        {t("SELECT BALANCE")}
      </label>

      <select
        id="withdraw-balance-type"
        value={balanceType}
        onChange={handleBalanceTypeChange}
        disabled={balanceLoading}
        className="digital-balance-select"
      >
        <option value="usdtBalanceOther">
          USDT+ • {Number(balanceSources.usdtBalanceOther || 0).toFixed(2)} USDT
        </option>

        <option value="usdtBalance">
          USDT Balance • {Number(balanceSources.usdtBalance || 0).toFixed(2)} USDT
        </option>
      </select>
    </div>
  )}
</section>



        


        {/* =================================================
            BET REQUIREMENT
        ================================================= */}

        <section
          className="digital-bet-requirement"
        >

          <div
            className="digital-bet-top"
          >

            <span>
              {t("WITHDRAWAL ELIGIBILITY")}
            </span>

            <strong>
              {betProgress} / {REQUIRED_BETS} BETS
            </strong>

          </div>


          <div
            className="digital-bet-track"
          >

            <div
              className="digital-bet-fill"

              style={{
                width:
                  `${betProgressPercent}%`,
              }}

            />

          </div>


          <div
            className="digital-bet-status"
          >

            {betsLoading

              ? "Checking betting activity..."

              : totalBets >= REQUIRED_BETS

                ? "✓ Withdrawal requirement completed"

                : `Complete ${
                    REQUIRED_BETS -
                    totalBets
                  } more bet${
                    REQUIRED_BETS -
                    totalBets === 1
                      ? ""
                      : "s"
                  } to withdraw`

            }

          </div>

        </section>


        {/* =================================================
            DESTINATION / WALLET
        ================================================= */}

        <section
          className="digital-section"
        >

          <div
            className="digital-section-heading"
          >

            <div
              className="heading-icon"
            >
              ◈
            </div>


            <div>

              <strong>
                {t("Destination")}
              </strong>

              <small>
                {t("Select receiving wallet")}
              </small>

            </div>

          </div>


          {loading ? (

            <div
              className="digital-loading-box"
            >

              <div
                className="digital-spinner"
              />

              <span>
                {t("Loading wallets...")}
              </span>

            </div>

          ) : (

            <>

              <div
                className="digital-wallet-select-wrap"
              >

                <select
                  value={
                    selectedWallet
                  }

                  onChange={
                    handleWalletChange
                  }

                  className="digital-wallet-select"
                >

                  <option value={-1}>
                    {t("Select crypto wallet")}
                  </option>


                  {wallets.map(
                    (
                      wallet,
                      index
                    ) => (

                      <option
                        key={
                          `${wallet.coin}-${index}`
                        }

                        value={
                          index
                        }
                      >

                        {wallet.coin}
                        {" • "}
                        {wallet.network || t("Network")}

                      </option>

                    )
                  )}

                </select>

              </div>


              {selectedWalletData && (

                <div
                  className="digital-wallet-preview"
                >

                  <div
                    className="wallet-preview-top"
                  >

                    <div
                      className="wallet-coin-badge"
                    >

                      {isBTCWallet
                        ? "₿"
                        : "₮"
                      }

                    </div>


                    <div
                      className="wallet-preview-name"
                    >

                      <strong>
                        {
                          selectedWalletData.coin
                        }
                      </strong>

                      <span>
                        {
                          selectedWalletData.network ||
                          "Network"
                        }
                      </span>

                    </div>


                    <div
                      className="wallet-verified"
                    >
                      ✓ VERIFIED
                    </div>

                  </div>


                  <div
                    className="wallet-address-box"
                  >

                    <span>
                      {t("RECEIVING ADDRESS")}
                    </span>

                    <code>
                      {
                        maskAddress(
                          selectedWalletData.address
                        )
                      }
                    </code>

                  </div>

                </div>

              )}

            </>

          )}

        </section>


        {/* =================================================
            WITHDRAWAL SPEED
        ================================================= */}

        <section
          className={
            withdrawalSpeedError
              ? "digital-section digital-speed-section speed-error"
              : "digital-section digital-speed-section"
          }
        >

          <div
            className="digital-section-heading"
          >

            <div
              className="heading-icon"
            >
              ⚡
            </div>


            <div>

              <strong>
                {t("Withdrawal Speed")}
              </strong>

              <small>
                {t("Select processing priority")}
              </small>

            </div>

          </div>


          <div
            className="digital-speed-select-wrap"
          >

            <select
              value={
                withdrawalType
              }

              onChange={
                handleWithdrawalSpeedChange
              }

              className={
                withdrawalSpeedError
                  ? "digital-speed-select error"
                  : "digital-speed-select"
              }
            >

              <option value="">
                {t("Select withdrawal speed")}
              </option>


              {withdrawalOptions.map(
                (option) => (

                  <option
                    key={option.id}
                    value={option.id}
                  >

                    {t(option.label)}
                    {" • "}
                    {option.time}
                    {" • "}
                    {option.fee}%
                    {" Fee"}

                  </option>

                )
              )}

            </select>

          </div>


          {selectedWithdrawalOption && (

            <div
              className="digital-speed-preview"
            >

              <div
                className="speed-preview-icon"
              >
                ⚡
              </div>


              <div
                className="speed-preview-info"
              >

                <strong>
                  {
                    selectedWithdrawalOption.label
                  }
                </strong>

                <span>
                  Processing time:{" "}
                  {
                    selectedWithdrawalOption.time
                  }
                </span>

              </div>


              <div
                className="speed-preview-fee"
              >

                <strong>
                  {
                    selectedWithdrawalOption.fee
                  }%
                </strong>

                <span>
                  {t("FEE")}
                </span>

              </div>

            </div>

          )}


          {withdrawalSpeedError && (

            <div
              className="digital-speed-error"
            >

              <span>
                !
              </span>

              <p>
                {withdrawalSpeedError}
              </p>

            </div>

          )}

        </section>


        {/* =================================================
            AMOUNT
        ================================================= */}

        <section
          className="digital-section amount-terminal"
        >

          <div
            className="digital-section-heading"
          >

            <div
              className="heading-icon"
            >
              $
            </div>


            <div>

              <strong>
                {t("Withdrawal Amount")}
              </strong>

              <small>
                {t("Enter amount in USDT")}
              </small>

            </div>

          </div>


          <div
            className={
              amountError
                ? "digital-amount-input error"
                : "digital-amount-input"
            }
          >

            <input
              type="number"

              min={
                MINIMUM_WITHDRAW
              }

              max={
                MAXIMUM_WITHDRAW
              }

              value={
                amount
              }

              onChange={
                handleAmountChange
              }

              placeholder="0.00"
            />


            <span>
              USDT
            </span>


            <button
              type="button"
              onClick={handleMax}
            >
              MAX
            </button>

          </div>


          {amountError && (

            <div
              className="digital-amount-error"
            >

              <span>
                !
              </span>

              {amountError}

            </div>

          )}


          <div
            className="digital-amount-limits"
          >

            <span>
              MIN
              <b>
                {MINIMUM_WITHDRAW}
              </b>
            </span>


            <span>
              MAX
              <b>
                {
                  MAXIMUM_WITHDRAW.toLocaleString()
                }
              </b>
            </span>

          </div>

        </section>


        {/* =================================================
            BTC RATE
        ================================================= */}

        {isBTCWallet && (

          <section
            className="digital-rate-card"
          >

            <div
              className="rate-left"
            >

              <div
                className="rate-icon"
              >
                ₿
              </div>


              <div>

                <span>
                  {t("LIVE BTC RATE")}
                </span>

                <strong>

                  {rateLoading
                    ? t("Updating...")
                    : conversionText
                  }

                </strong>

              </div>

            </div>


            <div
              className={
                rateLoading
                  ? "rate-dot loading"
                  : "rate-dot"
              }
            />

          </section>

        )}


        {/* =================================================
            CONFIRM WITHDRAWAL
        ================================================= */}

        <button
          type="button"

          className="digital-withdraw-submit"

          onClick={
            handleSubmit
          }

          disabled={
            loading ||
            balanceLoading ||
            betsLoading
          }
        >

          <span>

            {betsLoading
              ? "CHECKING ELIGIBILITY..."

              : totalBets < REQUIRED_BETS
                ? `COMPLETE ${
                    REQUIRED_BETS - totalBets
                  } MORE BET${
                    REQUIRED_BETS - totalBets === 1
                      ? ""
                      : "S"
                  }`

                : "CONFIRM WITHDRAWAL"
            }

          </span>

          <b>
            →
          </b>

        </button>


        {/* =================================================
            TRANSACTION PREVIEW
        ================================================= */}

        <section
          className="digital-summary"
        >

          <div
            className="summary-title"
          >

            <span>
              {t("TRANSACTION PREVIEW")}
            </span>

            <i>
              {t("SECURE")}
            </i>

          </div>


          <div
            className="summary-line"
          >

            <span>
              Amount
            </span>

            <strong>

              {amountNumber > 0
                ? amountNumber.toFixed(2)
                : "0.00"
              }

              {" "}
              USDT

            </strong>

          </div>


          <div
            className="summary-line"
          >

            <span>
              {t("Withdrawal speed")}
            </span>

            <strong>

              {selectedWithdrawalOption
                ? selectedWithdrawalOption.label
                : "-"
              }

            </strong>

          </div>


          <div
            className="summary-line"
          >

            <span>
              {t("Processing time")}
            </span>

            <strong>

              {selectedWithdrawalOption
                ? selectedWithdrawalOption.time
                : "-"
              }

            </strong>

          </div>


          <div
            className="summary-line"
          >

            <span>
              {t("Processing fee")}
            </span>

            <strong>

              {selectedWithdrawalOption
                ? `${withdrawalFee}%`
                : "-"
              }

              {" • "}

              {feeAmount.toFixed(2)}

              {" "}
              USDT

            </strong>

          </div>


          <div
            className="summary-divider"
          />


          <div
            className="summary-receive"
          >

            <div>

              <span>
                {t("YOU RECEIVE")}
              </span>

              <small>
                {t("After processing fee")}
              </small>

            </div>


            <strong>

              {displayReceiveAmount}

              <small>
                {receiveCurrency}
              </small>

            </strong>

          </div>

        </section>


        {/* =================================================
            SECURITY
        ================================================= */}

        <div
          className="digital-security-info"
        >

          <span>
            ✓
          </span>

          <p>
            {t("Funds will be sent to the wallet selected above. Always verify the receiving address and network before continuing.")}
          </p>

        </div>


        {/* =================================================
            BACK
        ================================================= */}

        <button
          type="button"

          className="digital-return-button"

          onClick={
            handleBack
          }
        >

          ← BACK

        </button>


      </main>

    </div>

  );

}
